export default "__VITE_ASSET__D0mlP8wT__"